import {
	PurPaymentDetailDto,
	PurPaymentHeaderDto,
	defaultPurPaymentDetailDto,
	defaultPurPaymentHeaderDto,
} from "src/dtos/purPayment/purPaymentViewDto";
import { formatDate } from "src/utils/string/stringUtil";

export interface PUR6010_R01Dto {
	purPaymentHeaderDto: PUR6010_R01HeaderDto;
	purPaymentDetailDtoList: PUR6010_R01DetailDto[];
}

export interface PUR6010_R01HeaderDto extends PurPaymentHeaderDto {
	tradeNo: string;
	tradeType: string;	// 지불구분 예외여부 Y/N
	tradeDt: string;
	tradeAmt: number;
}

export const defaultPUR6010_R01HeaderDto: PUR6010_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	paymentNo: '',
	compCd: '',
	compNm: '',
	paymentDt: formatDate(new Date()),
	customCd: '',
	customNm: '',
	paymentType: '',
	empNo: '',	
	empNm: '',
	moneyCd: '',
	moneyRate: 0,
	paymentAmt: 0,
	cashAmt: 0,
	cardAmt: 0,
	cmsAmt: 0,
	bankbookAmt: 0,
	bankCd: '',
	bankAcctNo: '',
	noteAmt: 0,
	noteNo: '',
	noteCreateFlg: '',
	issueDt: formatDate(new Date()),
	dueDt: formatDate(new Date()),
	noteBankCd: '',
	publisher: '',
	endorseCnt: 0,
	dcAmt: 0,
	advancesFee: 0,
	advancesFeeNo: '',
	approveFlg: '',
	exceptionFlg: 'N',
	remark: '',

	tradeNo: '',
	tradeType: '',
	tradeDt: formatDate(new Date()),
	tradeAmt: 0,

	inserted: false,
	isModified: false,
}


export interface PUR6010_R01DetailDto extends PurPaymentDetailDto {

	itemNo: string;
    purchaseBillNo: string;
    itemCd: string;
    itemNm: string;
    itemSpec: string;
    modelNo: string;
    billUnit: string;
    compCd: string;
    customCd: string;
    purchaseDt: string;
    itemSeq: number;
    billQty: number;
    billPrice: number;
    dcAmt: number;
    billAmt: number;
    checkProcess: string;
	tradeNo: string;
}

export const defaultPUR6010_R01DetailDto: PUR6010_R01DetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	tradeDt: formatDate(new Date()),
	tradeType: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemPrice: 0,
	vatAmt: 0,
	billAmt: 0,
	paymentAmt: 0,

	itemNo: '',
	purchaseBillNo: '',
	modelNo: '',
	billUnit: '',
	compCd: '',
	customCd: '',
	purchaseDt: formatDate(new Date()),
	itemSeq: 0,
	billQty: 0,
	billPrice: 0,
	dcAmt: 0,
	checkProcess: 'N',
	tradeNo: '',

	inserted: false,
	isModified: false
}
